module.exports = __webpack_public_path__ + "img/2.539177b9.jpg";